exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".StickyNavigation {\n  position: relative;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 20; }\n", ""]);

// exports
